import { defineComponent, useModel, openBlock, createBlock, unref, createSlots, withCtx, renderSlot, createVNode, createTextVNode, mergeModels } from 'vue';
import { ElDialog, ElButton } from 'element-plus';
/* empty css                                                                                                                                        */
/* empty css                                                                                                                                             */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                             */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "dialog",
  props: /* @__PURE__ */ mergeModels({
    modal: { type: Boolean, default: false },
    title: { default: "" },
    width: { default: "50%" },
    showClose: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    alignCenter: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false },
    destroyOnClose: { type: Boolean, default: false }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["open", "opened", "close", "closed", "openAutoFocus", "closeAutoFocus", "submit"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const model = useModel(__props, "modelValue");
    const emit = __emit;
    function submitHandler() {
      emit("submit");
    }
    function openHandler() {
      emit("open");
    }
    function openedHandler() {
      emit("opened");
    }
    function closeHandler() {
      emit("close");
    }
    function closedHandler() {
      emit("closed");
    }
    function openAutoFocusHandler() {
      emit("openAutoFocus");
    }
    function closeAutoFocusHandler() {
      emit("closeAutoFocus");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(ElDialog), {
        modelValue: model.value,
        "onUpdate:modelValue": ($event) => model.value = $event,
        modal: __props.modal,
        title: __props.title,
        width: __props.width,
        "align-center": __props.alignCenter,
        "show-close": __props.showClose,
        "append-to-body": __props.appendToBody,
        "destroy-on-close": __props.destroyOnClose,
        draggable: "",
        onOpen: openHandler,
        onOpened: openedHandler,
        onClose: closeHandler,
        onClosed: closedHandler,
        onOpenAutoFocus: openAutoFocusHandler,
        onCloseAutoFocus: closeAutoFocusHandler
      }, createSlots({
        header: withCtx(() => [
          renderSlot(_ctx.$slots, "header")
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        __props.showFooter ? {
          name: "footer",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "footer", {}, () => [
              createVNode(unref(ElButton), {
                type: "primary",
                onClick: submitHandler
              }, {
                default: withCtx(() => [
                  createTextVNode("确定")
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "onUpdate:modelValue", "modal", "title", "width", "align-center", "show-close", "append-to-body", "destroy-on-close"]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=dialog.vue.js.map
